import { api } from './api';

export interface Webhook {
  id: string;
  name: string;
  url: string;
  events: string[];
  secret: string;
  isActive: boolean;
  headers: Record<string, string>;
  createdAt: string;
  updatedAt: string;
  _count?: { logs: number };
}

export interface WebhookLog {
  id: string;
  webhookId: string;
  event: string;
  direction: string;
  payload: unknown;
  response: unknown;
  statusCode: number | null;
  success: boolean;
  error: string | null;
  processedAt: string | null;
  createdAt: string;
}

class WebhooksService {
  async findAll(): Promise<Webhook[]> {
    const { data } = await api.get('/webhooks');
    return data?.data || data;
  }

  async create(dto: {
    name: string;
    url: string;
    events: string[];
    secret?: string;
    headers?: Record<string, string>;
    isActive?: boolean;
  }): Promise<Webhook> {
    const { data } = await api.post('/webhooks', dto);
    return data?.data || data;
  }

  async update(id: string, dto: Partial<Webhook>): Promise<Webhook> {
    const { data } = await api.put(`/webhooks/${id}`, dto);
    return data?.data || data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/webhooks/${id}`);
  }

  async getLogs(
    id: string,
    page = 1,
    limit = 20,
  ): Promise<{ data: WebhookLog[]; meta: { total: number; page: number } }> {
    const { data } = await api.get(`/webhooks/${id}/logs`, {
      params: { page, limit },
    });
    return data?.data || data;
  }

  async sendTest(id: string): Promise<void> {
    await api.post(`/webhooks/${id}/test`);
  }
}

export const webhooksService = new WebhooksService();
